module.exports = __webpack_public_path__ + "images/53b92353f4747ffb91750173239cb23a.png";